var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.label))]),_vm._t("default",null,{"date":_vm.date,"time":_vm.time})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }